import {InputAdornment, TextField, Button, Stack, Alert, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, CircularProgress} from '@mui/material';
import Layout from "../../../components/Frames/Layout";
import SearchIcon from '@mui/icons-material/Search';
import { useQuery} from 'react-query';
import {Csv} from '../../../services/API/Csv'
import { useState } from 'react';
import Tip from '../../Tools/Tip';


export default function List(){

    const {data, isSuccess, isError, isLoading} = useQuery('csv', () => Csv.getAll().then(r => r.data));

    const step = 10;
    const [limit, setLimit] = useState(step)
    const [search, setSearch] = useState({fast: ''})

    const [downloading, setDownloading] = useState(false);

    const match = i => i.title?.toLowerCase().includes(search.fast.toLowerCase())

    const list = !isSuccess ? [] : [...data]
        .filter(i => match(i))
        .sort((a,b) => a.title > b.title ? 1 : -1)

    
    const handleDownload = i => {

        Csv.download(i.id, i.title + '.csv')
            .then(r => setDownloading(false))
            .catch(e => setDownloading(false));

        return setDownloading(i.id);
    }


    return <Layout title="Extractions CSV" tab="csv" menu="admin">


        <Stack direction='row' justifyContent='space-between' sx={{flexWrap: 'wrap', mb: 1}}>

            <TextField
                label='Rechercher'
                type='search'
                size='small'
                value={search.fast || ''}
                onChange={e => setSearch({...search, fast: e.target.value})}
                InputProps={{
                    startAdornment: <InputAdornment position='start'><SearchIcon/></InputAdornment>
                }}
            />

        </Stack>

        {isError && <Alert severity="error">Vous êtes déconnecté. Les données n'ont pas pu être récupérées.</Alert>}

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell><b>Extractions</b></TableCell>
                        <TableCell align='right'><b>Télécharger</b></TableCell>
                    </TableRow>
                </TableHead>

                {isSuccess && <TableBody>

                    {list.slice(0, limit).map(i => 
                        <TableRow key={i.id}>
                            <TableCell>{i.title}</TableCell>
                            {downloading !== i.id ?
                                <TableCell align='right' onClick={() => handleDownload(i)}>
                                    <Tip type='download'/>
                                </TableCell>
                                :
                                <TableCell align='right'>
                                    <CircularProgress size={30} />
                                </TableCell>
                            }
                        </TableRow>    
                    )}

                </TableBody>}
            </Table>
        </TableContainer>

        {isSuccess && list.length > limit &&
            <Button onClick={() => setLimit(limit + step)}>Afficher la suite</Button>
        }

       {isLoading && <Stack direction='row' justifyContent='center' sx={{mt: 3}}>
            <CircularProgress size={24} />
        </Stack>}

    </Layout>
}







